import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { loadTermsOfService } from '../utils/legalLoader';
import LandingNav from '../components/shared/LandingNav';
import Seo from '../components/Seo';

const Section = ({ title, children }) => (
  <section style={{ margin: '24px 0' }}>
    <h3 style={{ marginBottom: 12 }}>{title}</h3>
    <div style={{ opacity: 0.95 }}>{children}</div>
  </section>
);

const ContentRenderer = ({ content }) => {
  return content.map((item, idx) => {
    if (item.type === 'paragraph') {
      return <p key={idx}>{item.text}</p>;
    } else if (item.type === 'bullet') {
      return (
        <ul key={idx}>
          <li>{item.text}</li>
        </ul>
      );
    } else if (item.type === 'strong') {
      return (
        <p key={idx}>
          <strong>{item.text}</strong>
        </p>
      );
    }
    return null;
  });
};

const Terms = () => {
  const [legalContent, setLegalContent] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => { 
    window.scrollTo(0, 0);
    
    loadTermsOfService().then(content => {
      setLegalContent(content);
      setLoading(false);
    });
  }, []);

  return (
    <div style={{ padding: '24px 0' }}>
      <Seo
        title="Terms of Service | PrecisionTrader"
        description="PrecisionTrader Terms of Service — the terms that govern your use of the platform."
        canonicalPath="/terms"
      />
      {/* Navigation (match Landing/Pricing style) */}
      <LandingNav />
      <div style={{ maxWidth: 900, margin: '0 auto', padding: '0 16px' }}>
        {loading ? (
          <div>Loading...</div>
        ) : legalContent ? (
          <>
            <h1 style={{ marginBottom: 8 }}>{legalContent.title}</h1>
            {legalContent.lastUpdated && (
              <div style={{ color: 'var(--text-light)', marginBottom: 24 }}>
                Last Updated: {legalContent.lastUpdated}
              </div>
            )}

            {legalContent.sections.map((section, idx) => (
              <Section key={idx} title={section.title}>
                {section.content.map((item, itemIdx) => {
                  if (item.type === 'paragraph') {
                    return <p key={itemIdx}>{item.text}</p>;
                  } else if (item.type === 'bullet') {
                    return (
                      <ul key={itemIdx} style={{ marginLeft: 0, paddingLeft: 20 }}>
                        <li>{item.text}</li>
                      </ul>
                    );
                  } else if (item.type === 'strong') {
                    return <p key={itemIdx}><strong>{item.text}</strong></p>;
                  }
                  return null;
                })}
              </Section>
            ))}

            <div style={{ marginTop: 24 }}>
              <Link to="/privacy" style={{ color: 'var(--accent)' }}>View Privacy Policy</Link>
            </div>
          </>
        ) : (
          <div>Error loading terms of service</div>
        )}
      </div>
    </div>
  );
};

export default Terms;
